import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { DocumentoAllegato } from '../../../models/documento-allegato';
import { FascicoloMap } from '../../../models/fascicolo-map';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { DocumentoAllegatoAdapter } from './documento-allegato-adapter';
import { DocumentUpdateMetadatiFormComponent } from './documento-update-metadati-form.component';

declare var closeModal: any;
declare var openModal: any;
declare var getFascicoloMapSync: any;

@Component({
    selector: '[doc_update_metadati_modal]',
  templateUrl: 'document-update-metadati-modal.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class DocumentUpdateMetadatiModal {
  @Output()
  onReturn: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('docUpdateMetadatiForm')
  documentUpdateMetadatiForm: DocumentUpdateMetadatiFormComponent;

  @Input() fascicolo: any;

  @Input() separatorePathLogico: string;

  @Input() tipoPratica: string;

  documento: DocumentoAllegato;

  constructor(private operationService: OperationsService, private helpers: HelpersService) {}

  initForm(documento, isSearchModule: boolean= false, esn?: string, isCensimentoDocumenti: boolean = false) {
    if (!isSearchModule) {
      this.documento = new DocumentoAllegatoAdapter(documento).documento;
      this.documentUpdateMetadatiForm.buildForm(documento, this.fascicolo, this.tipoPratica, esn, isCensimentoDocumenti);
      openModal('docUpdateMetadatiModal');
    } else {
      if (isSearchModule) {
        this.getFascicoloFull(documento);
        this.tipoPratica = documento.praticaLight.tipoPratica.id;
        this.helpers.getDocumentoAllegato(documento.intestazione.campi.idDocumento).subscribe(response => this.initFormFromSearchModule(response.documento, this.fascicolo));
      }
    }
  }

  initFormFromSearchModule(documentoAllegato: DocumentoAllegato, fascicolo) {
      this.documento = new DocumentoAllegatoAdapter(documentoAllegato).documento;
      this.documentUpdateMetadatiForm.buildForm(this.documento, fascicolo, this.tipoPratica);
      openModal('docUpdateMetadatiModal');
  }

  // CREAZIONE RAPIDA
  initFormCreazioneRapida(documento,  modalName: string, esn?: string, isCensimentoDocumenti: boolean = false) {
    this.documento = new DocumentoAllegatoAdapter(documento).documento;
    this.documentUpdateMetadatiForm.buildForm(documento, this.fascicolo, this.tipoPratica, esn, isCensimentoDocumenti);
    openModal(modalName);
  }

  getFascicoloMap(fascicolo, pratica): FascicoloMap {
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[fascicolo.tipoFascicolo.id];
    // let nomePraticaFE = FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
    return <FascicoloMap>getFascicoloMapSync(pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
  }

  getFascicoloFull(documento) {
      let fascicoloFull: FascicoloFull;
      let fascicoloMap: FascicoloMap = this.getFascicoloMap(documento.praticaLight.fascicoliLight[0], documento.praticaLight);
      let idFascicoloAssociato = documento.entitaAssociate[1];
      this.operationService.readFascicolo(fascicoloMap.pathView, idFascicoloAssociato).subscribe(response => this.fascicolo = response.fascicolo);
  }

  createForm(documento: DocumentoAllegato) {
    this.documento = new DocumentoAllegatoAdapter(documento).documento;
    this.documentUpdateMetadatiForm.createForm(documento);
  }

  manageModal(sezione: string) {
    if (sezione) {
      closeModal('docUpdateMetadatiModal');
      this.onReturn.emit(sezione);
    }
  }
}
